import { registerThemeSpec } from '@xhs/yam-beer/core/system/utils/themeSpec'

export default function initStyle() {
  return [
    registerThemeSpec('cmp.video', {
      container: {
        position: 'relative',
        m: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        bg: 'black',
        video: {
          width: '100%',
          '&[data-portrait]': {
            height: '100%',
            width: 'unset',
          },
        },
      },
      arrow: {
        position: 'absolute',
        top: '50%',
        cursor: 'pointer',
        fill: 'white',
        transform: 'translateY(-50%)',
      },
      fullScreen: {
        container: {
          position: 'fixed',
          bg: 'rgba(0,0,0,0.6)',
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          zIndex: 700,
          video: {
            pt: 83,
            pb: 64,
            px: 152,
            maxHeight: 640,
            maxWidth: 1136,
          },
        },
        controlsWrapper: {
          bg: 'rgba(0,0,0,0.4)',
        },
      },
      title: {
        position: 'absolute',
        bg: 'rgba(0,0,0,0.4)',
        top: 0,
        left: 0,
        right: 0,
        py: 12,
        px: 32,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        color: 'white',
        svg: {
          cursor: 'pointer',
          fill: 'white',
        },
        fontWeight: 'bold',
        fontSize: '14px',
        lineHeight: '22px',
      },
      progressWrapper: {
        position: 'relative',
        pb: 12,
        mt: 12,
        display: 'flex',
        cursor: 'pointer',
      },
      progress: {
        width: '100%',
        height: 3,
        overflow: 'hidden',
        border: 'none',
        borderRadius: '2px',
        bg: 'rgba(255, 255, 255, 0.4)',
        color: 'brand',
        '&::-moz-progress-bar': {
          bg: 'brand',
        },
        '&::-webkit-progress-bar': {
          bg: 'rgba(255, 255, 255, 0.4)',
        },
        '&::-webkit-progress-value': {
          bg: 'brand',
        },
      },
      progressDot: {
        size: 9,
        bg: 'brand',
        content: '""',
        position: 'absolute',
        borderRadius: '100%',
        top: -3,
        left: 0,
        transform: 'translateX(-3px)',
      },
      rowCenter: {
        display: 'flex',
        alignItems: 'center',
      },
      controls: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        color: 'white',
        svg: {
          cursor: 'pointer',
          fill: 'white',
        },
        '.icon-list': {
          svg: {
            mr: 24,
            '&:last-of-type': {
              mr: 8,
            },
          },
        },
      },
      controlsWrapper: {
        position: 'absolute',
        bottom: 0,
        left: 0,
        right: 0,
        background: 'linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.24) 100%)',
        whiteSpace: 'nowrap',
        pt: 16,
        pb: 4,
        px: 24,
        lineHeight: 18,
        fontSize: 14,
      },
    }),
  ]
}
